import { Textarea } from 'shared/ui/Textarea'
import { Scrollbar } from 'shared/ui/Scrollbar'
import { IntegrationKey } from 'entities/Integrations'
import type { IInstructionsFieldItem } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/instructionsWidgetStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IInstructionsStep3Props = {
  selectedFields: IInstructionsFieldItem[]
  promptText: string
  onPromptChange: (value: string) => void
}

export const InstructionsStep3 = ({
  selectedFields,
  promptText,
  onPromptChange,
}: IInstructionsStep3Props) => (
  <div className={styles.descriptionStep}>
    <Scrollbar autoHeight autoHeightMax={290}>
      {selectedFields.length > 0 && (
        <div className={styles.fieldChips}>
          {selectedFields.map((field) => (
            <span key={field.key} className='mergeField-wrap'>
              <span className={`mergeField-content mergeField-${field.integrationKey}`}>
                {field.name}
              </span>
              {field.integrationKey !== IntegrationKey.salesmessage && (
                <span
                  className={`mergeField-integration-status mergeField-${
                    field.isConnected ? 'connected' : 'disconnected'
                  }`}
                />
              )}
            </span>
          ))}
        </div>
      )}
    </Scrollbar>
    <Textarea
      value={promptText}
      onChange={onPromptChange}
      placeholder='Enter instructions'
      rows={2}
      className={styles.textarea}
    />
  </div>
)
